import { PopupProps } from './search-popup';
import css from './menu-modal.module.scss';
import Modal from 'src/components/common/modal/modal';
import Dropdown from '../navbar/dropdown';
import { useState } from 'react';
import { MenuCategory } from 'src/types';

function MenuPopup({ onOpen, onClose, trigger }: Readonly<PopupProps<MenuCategory>>) {
  const [closeOnClick, setCloseOnClick] = useState(true);
  return (
    <Modal onOpen={onOpen} onClose={onClose} trigger={trigger} closeOnDocumentClick={closeOnClick}>
      {(close: () => void) => (
        <div className={css.menuPopup}>
          <div className={css.container}>
            <Dropdown
              setCloseOnClick={setCloseOnClick}
              onClose={() => {
                close();
                onClose?.();
              }}
            />
          </div>
        </div>
      )}
    </Modal>
  );
}

export default MenuPopup;
